import { Button } from "@appkit4/react-components";
import { useEffect, useState } from "react";
import SectionLoader from "../components/sectionLoader/SectionLoader";
import { LOCAL_KEYS } from "../services/GroupContext";
import { resetGroupDataSync } from "../services/storage/groupDataStorage";

const Logout = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // When redirected here from Entra ID logout, clear local auth state
    // Entra ID has already revoked the token on their servers
    localStorage.removeItem(LOCAL_KEYS.user);
    localStorage.removeItem(LOCAL_KEYS.lastRequest);
    resetGroupDataSync();
    setLoading(false);
  }, []);

  if (loading) {
    return <SectionLoader />;
  }

  return (
    <div className="ap-container">
      <h1>You have been logged out!</h1>
      <Button
        onClick={() => {
          window.location.assign("/");
        }}
      >
        Log back in
      </Button>
    </div>
  );
};

export default Logout;
